<template>
  <div>
    <b-form-group
      label="Başlık"
      label-for="title"
    >
      <b-form-input
        id="title"
        v-model="itemData.translate.title"
        placeholder="Başlık"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.title }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Kısa Açıklama"
      label-for="summary"
    >
      <b-form-textarea
        id="summary"
        v-model="itemData.translate.summary"
        placeholder="Kısa Açıklama"
      />
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          {{ itemData.item.summary }}
        </div>
      </b-alert>
    </b-form-group>
    <b-form-group
      label="Metin"
      label-for="subtitle"
    >
      <quill-editor
        id="content"
        v-model="itemData.translate.content"
        class="bg-white"
        :options="editorOption"
      >
        <div
          id="content_toolbar"
          slot="toolbar"
        >
          <editor-toolbar />
        </div>
      </quill-editor>
      <b-alert show>
        <div class="alert-body mt-1 font-small-2">
          <div v-html="itemData.item.content" />
        </div>
      </b-alert>
    </b-form-group>
    <b-button
      variant="primary"
      size="sm"
      @click="saveAction"
    >
      <FeatherIcon icon="SaveIcon" />
      Kaydet
    </b-button>
  </div>
</template>
<script>
import {
  BFormGroup, BFormInput, BFormTextarea, BAlert, BButton,
} from 'bootstrap-vue'
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import EditorToolbar from '@/layouts/components/common/EditorToolbar.vue'

export default {
  name: 'Contents',
  components: {
    EditorToolbar,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BAlert,
    BButton,
    quillEditor,
  },
  props: {
    saveAction: {
      type: Function,
      require: true,
    },
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: '#content_toolbar',
        },
        theme: 'snow',
      },
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['translate/dataItem']
    },
  },
}
</script>
